export default "__VITE_ASSET__222d5334__"